module.exports = __webpack_public_path__ + "static/stroke-49b681fae84282bd067c12111c9ed5a2.svg";